export const multiGuard = (guards) => async (to, from, next) => {
  let redirect = false;

  const redirectNext = (location) => {
    if (location) {
      redirect = true;
      next(location);
    }
  };

  for (const guard of guards) {
    await guard(to, from, redirectNext);

    if (redirect) break;
  }

  if (!redirect) next();
};

const PRELOAD_DELAY_MS = 3000;

const isLazyComponent = (component) =>
  typeof component === "function" && !("displayName" in component);

export const preloadRouteComponents = (router) => {
  const loaders = router
    .getRoutes()
    .flatMap(({ components }) => Object.values(components ?? {}))
    .filter(isLazyComponent);
  setTimeout(
    () => Promise.allSettled(loaders.map((load) => load())),
    PRELOAD_DELAY_MS
  );
};
